type AliasesModules = Record<string, Record<string, string> | undefined>;

// Staging and mockprod are deployed together (frontend and backend), so their
// aliases files are interchangeable. Production may run a different version and
// has no fallback.
const FALLBACK_ENV: Record<string, string> = {
  mockprod: 'staging',
  staging: 'mockprod',
};

const aliasesFor = (modules: AliasesModules, env: string) =>
  modules[`../__generated__/aliases_${env}.json`];

/**
 * Pick the persisted-query aliases for `env` from the `import.meta.glob`
 * result, falling back to the sibling env's file when this env's sync failed at
 * build time (e.g. a mockprod reset during CI).
 */
export const resolveAliases = (
  modules: AliasesModules,
  env: string
): Record<string, string> => {
  const fallbackEnv = FALLBACK_ENV[env];
  return (
    aliasesFor(modules, env) ??
    (fallbackEnv ? aliasesFor(modules, fallbackEnv) : undefined) ??
    {}
  );
};
